module.exports = __webpack_public_path__ + "img/logo-dronspot.7e7071fe.png";